// extracted by mini-css-extract-plugin
export var bodyFooterButton = "DefaultSubscribeForm-module--body-footer-button--eecea";
export var disclaimerText = "DefaultSubscribeForm-module--disclaimer-text--c1a7e";
export var extraFieldsContainer = "DefaultSubscribeForm-module--extra-fields-container--8d015";
export var form = "DefaultSubscribeForm-module--form--66b1e";
export var inputContainer2Cols = "DefaultSubscribeForm-module--input-container-2-cols--caa9e";
export var inputTitleContainer = "DefaultSubscribeForm-module--input-title-container--3c3a0";
export var requiredFieldsLabel = "DefaultSubscribeForm-module--required-fields-label--f70ad";